import React, { useEffect, useState } from 'react';
import { Box, Button } from '@mui/material';
import { getDownloadURL, ref, listAll } from 'firebase/storage'; 
import { storage } from '../firebase/firebaseConfig'; 
import { SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './SliderFotos.css';

const SlidesFotosApp = () => {
  const [imageUrls, setImageUrls] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchImages = async () => {
      const listRef = ref(storage, 'fotoslidermisappcalocho/');
      const res = await listAll(listRef);
      const urls = await Promise.all(
        res.items.map(async (itemRef) => {
          const url = await getDownloadURL(itemRef);
          return url;
        })
      );
      setImageUrls(urls);
      setLoading(false);
    };

    fetchImages();
  }, []);

  useEffect(() => {
    if (imageUrls.length > 0) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % imageUrls.length);
      }, 5000); 

      return () => clearInterval(interval);
    }
  }, [imageUrls]);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + imageUrls.length) % imageUrls.length);
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % imageUrls.length);
  };

  if (loading) {
    return <p>Cargando imágenes...</p>;
  }

  return (
    <Box
      sx={{
        position: 'relative',
        width: { xs: '100%', sm: '90%', md: '80%' },
        height: { xs: '50vh', md: '80vh' },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        padding: { xs: '2%', md: '3%' },
      }}
    >
      <SwiperSlide
        key={imageUrls[currentIndex]}
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
        }}
      >
        <Button
          variant="text"
          onClick={handlePrev}
          sx={{
            fontSize: { xs: '40px', sm: '60px', md: '80px' },
            position: 'absolute',
            left: { xs: '5%', md: '2%' },
            top: '50%',
            transform: 'translateY(-50%)',
            color: '#8E0505',
          }}
        >
          {'<'}
        </Button>

        <Button
          variant="text"
          onClick={handleNext}
          sx={{
            fontSize: { xs: '40px', sm: '60px', md: '80px' },
            position: 'absolute',
            right: { xs: '5%', md: '2%' },
            top: '50%',
            transform: 'translateY(-50%)',
            color: '#8E0505',
          }}
        >
          {'>'}
        </Button>

        <img
          src={imageUrls[currentIndex]}
          alt={`Slide ${currentIndex}`}
          className="slider-image"
          style={{
            width: '100%',
            height: 'auto',
            maxHeight: '100%',
            objectFit: 'cover',
          }}
        />
      </SwiperSlide>
    </Box>
  );
};

export default SlidesFotosApp;